var _style, _g, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartisanLogoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42.5 10.2",
    style: {
      enableBackground: "new 0 0 42.5 10.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000121264025044472351580000017020986506438378883_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.8,5.3L10.8,5.3c0-1.8,1.2-3.1,2.9-3.1c1.4,0,2.4,0.7,2.5,2.1h-1.1c-0.1-0.8-0.6-1.2-1.4-1.2c-1,0-1.7,0.8-1.7,2.1v0.1 c0,1.3,0.6,2.1,1.7,2.1c0.8,0,1.4-0.4,1.5-1.3h1.1c-0.2,1.4-1.2,2.1-2.6,2.1C11.8,8.3,10.8,7.1,10.8,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7,6.7V6.3h-0.5c-0.8,0-1.3,0.2-1.3,0.7c0,0.4,0.2,0.6,0.7,0.6C19.2,7.6,19.7,7.3,19.7,6.7 M16.9,7c0-1,1-1.4,2.2-1.4 h0.5V5.4c0-0.6-0.2-0.9-0.8-0.9c-0.5,0-0.8,0.2-0.8,0.7h-1c0.1-1,0.9-1.4,1.9-1.4c1,0,1.7,0.4,1.7,1.6v2.8h-1V7.7 c-0.3,0.4-0.7,0.6-1.3,0.6C17.5,8.3,16.9,7.9,16.9,7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6,3.9h1v0.8c0.3-0.5,0.7-0.9,1.4-0.9v0.9c-0.9,0-1.4,0.3-1.4,1.2v2.3h-1V3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2,7V4.7h-0.6V3.9h0.6v-1h1v1h1v0.8h-1v2.3c0,0.4,0.2,0.6,0.5,0.6c0.2,0,0.3,0,0.5-0.1v0.8c-0.2,0.1-0.4,0.1-0.7,0.1 C25.6,8.3,25.2,7.8,25.2,7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,3.9h1v4.3h-1V3.9z M27.9,2.6c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.2,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C28.2,3.2,27.9,2.9,27.9,2.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8,6.9h0.9c0,0.4,0.3,0.7,0.9,0.7c0.5,0,0.8-0.2,0.8-0.6c0-0.4-0.3-0.5-0.9-0.6c-1.1-0.2-1.6-0.5-1.6-1.3 c0-0.9,0.8-1.3,1.6-1.3c0.9,0,1.6,0.3,1.7,1.3h-0.9c-0.1-0.4-0.3-0.6-0.8-0.6c-0.4,0-0.7,0.2-0.7,0.5c0,0.3,0.2,0.4,0.9,0.6 c1,0.2,1.6,0.4,1.6,1.3c0,0.9-0.6,1.4-1.7,1.4C30.5,8.3,29.9,7.8,29.8,6.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7,6.7V6.3h-0.5c-0.8,0-1.3,0.2-1.3,0.7c0,0.4,0.2,0.6,0.7,0.6C36.2,7.6,36.7,7.3,36.7,6.7 M33.9,7c0-1,1-1.4,2.2-1.4 h0.5V5.4c0-0.6-0.2-0.9-0.8-0.9c-0.5,0-0.8,0.2-0.8,0.7h-1c0.1-1,0.9-1.4,1.9-1.4c1,0,1.7,0.4,1.7,1.6v2.8h-1V7.7 c-0.3,0.4-0.7,0.6-1.3,0.6C34.6,8.3,33.9,7.9,33.9,7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6,3.9h1v0.7c0.2-0.4,0.7-0.8,1.4-0.8c0.9,0,1.5,0.5,1.5,1.7v2.7h-1V5.6c0-0.7-0.3-1-0.9-1c-0.6,0-1,0.3-1,1v2.6h-1 C38.6,8.2,38.6,3.9,38.6,3.9z"
  }))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8,7.4C3.8,7.4,3.8,7.4,3.8,7.4L3.8,7.4C3.4,7,3,6.7,2.6,6.3C2.2,5.9,1.9,5.5,1.6,5.1c0,0,0,0,0,0 C0.3,6.7-0.3,8.2,0.2,8.7c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c2.3,2.2,5.4,1.8,7.2,0c0,0,0,0,0,0C7.4,8.8,6.6,9.6,3.8,7.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.5968,
    y1: 8.4985,
    x2: 3.2053,
    y2: 8.4985,
    gradientTransform: "matrix(1 0 0 -1 0 11.7069)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9839,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.5,1.6c0,0,0-0.1-0.1-0.1C6.9,1,5.4,1.6,3.8,2.9l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0.4,0.3,0.8,0.7,1.2,1 c0.4,0.4,0.7,0.7,1,1.1C6,5,6,5.1,6,5.1C7.2,3.6,7.8,2.2,7.5,1.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.2,1.5C0.2,1.5,0.2,1.5,0.2,1.5C0.2,1.5,0.2,1.5,0.2,1.5C0.2,1.5,0.2,1.5,0.2,1.5c-0.5,0.5,0.1,2,1.4,3.6c0,0,0,0,0,0 c0.3-0.4,0.7-0.8,1.1-1.2C3,3.5,3.4,3.2,3.8,2.9c0,0,0,0,0,0l0,0C5.4,1.6,6.9,1,7.4,1.5C5.6-0.3,2.5-0.7,0.2,1.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153691194976696351210000010788792708515949707_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.6917,
    y1: 6.6695,
    x2: 5.6917,
    y2: 1.1147,
    gradientTransform: "matrix(1 0 0 -1 0 11.7069)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9839,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000153691194976696351210000010788792708515949707_)"
    },
    d: "M7.5,8.6c0,0,0,0.1-0.1,0.1 c-0.5,0.5-2-0.1-3.6-1.4l0,0c0,0,0,0,0,0c0,0,0,0,0,0C4.2,7,4.6,6.7,5,6.3c0.4-0.4,0.7-0.7,1-1.1C6,5.2,6,5.2,6,5.1 C7.2,6.6,7.8,8,7.5,8.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartisanLogoBlack);
export default __webpack_public_path__ + "static/media/cartisan-logo-black.ad8f7f8af22de698fa4094e9005b1755.svg";
export { ForwardRef as ReactComponent };